import axios from 'axios';
import Config from './config';
const axiosInstance = axios.create({
  baseURL: Config.apiUrl,
  timeout: 25000,
  withCredentials: true,
  credentials: "include",
});

axiosInstance.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      alert('You are not authorized');
    }
    return response;
  },
  (error) => {
    if (error?.response && error.response?.status === 401) {
      return Promise.reject(error.response && error.response.data);
    }

    if (error?.code === 'ECONNABORTED') {
      return Promise.reject('Request timeout exceeded');
    }
    return Promise.reject(error.response.data);
  }
);
export default axiosInstance;
